// extracted by mini-css-extract-plugin
export default {"container":"groovePacker_container__S-xP2","aboutSec":"groovePacker_aboutSec__bwvzG"};